import type { ReactNode } from 'react';

import { Container } from '@/components/ui/Container';
import { Label } from '@/components/ui/Label';
import { Section } from '@/components/ui/Section';
import type { Releve } from '@/content/publications';

type ReleveSectionProps = {
  releve: Releve;
  /** Libellé de l'eyebrow : « Le Relevé hebdomadaire, semaine 03 ». */
  eyebrow: string;
  /** Bouton sous le texte : archives sur l'accueil, flux sur le blog. */
  action: ReactNode;
};

/** Le Relevé de la semaine : un élément par pilier (maquette, `.rel`). */
export function ReleveSection({ releve, eyebrow, action }: ReleveSectionProps) {
  return (
    <Section id="releve" tone="blanc" aria-labelledby="releve-titre">
      <Container className="grid items-start gap-8 desk:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] desk:gap-16">
        <div>
          <Label>{eyebrow}</Label>
          <h2 id="releve-titre" className="mt-4.5 text-h2">
            Chaque semaine, ce qui a changé.
          </h2>
          <p className="mt-4.5 max-w-[24em] text-sub text-encre-soft">
            Brouillon produit par le pipeline, relu et corrigé à la main. Le pipeline ne publie
            jamais seul.
          </p>
          <div className="mt-7">{action}</div>
        </div>

        <ul className="m-0 list-none border-t border-encre p-0">
          {releve.items?.map((item) => (
            <li
              key={item.title}
              className="grid gap-1 border-b border-line py-4.5 tab:grid-cols-[200px_minmax(0,1fr)] tab:gap-5"
            >
              <Label>{item.pilier}</Label>
              <span>
                <b className="block text-h6">{item.title}</b>
                <p className="mt-1 text-body-xs text-encre-soft">{item.body}</p>
              </span>
            </li>
          ))}
        </ul>
      </Container>
    </Section>
  );
}
